import React, { Component } from 'react'
import PropTypes from 'prop-types'
import arraySort from 'array-sort'
import Collapse from 'react-collapse'
import { FormattedMessage } from 'react-intl'

import PreviousReview from './PreviousReview'

import { getIntlReviewTypeWithContext } from '../../../../utils/review'
import {
  reviews as reviewsMessage,
  review,
  hidePrevious,
  older
} from '../../../../utils/messages'

export default class PreviousReviewsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: true
    }
    this.onExpandReviewsClickBound = this.onExpandReviewsClick.bind(this)
    this.onCollapseReviewsClickBound = this.onCollapseReviewsClick.bind(this)
  }

  render() {
    const { previousReviewsNoCurrent, reviews, reviewType } = this.props
    const { intl } = this.context
    const reviewsSorted = arraySort(reviews, ['completed_at'], {
      reverse: true
    })
    const previousReviewsCount = this.getPreviousReviewsCount()
    var prevReviews = reviewsSorted.map(function (review, index) {
      return (
        <PreviousReview
          review={review}
          key={index}
          previousNoCurrent={previousReviewsNoCurrent}
        />
      )
    })
    const intlReviewType = getIntlReviewTypeWithContext(
      reviewType,
      intl,
      'sentence'
    )

    return (
      <div>
        <Collapse isOpened={true} keepCollapsedContent={true}>
          <ul className={this.getListClass()}>{prevReviews}</ul>
        </Collapse>
        <div
          className={
            this.onePreviousNoCurrent() ? 'hide-display-more' : 'more-reviews'
          }
          onClick={
            this.state.collapsed === true
              ? this.onExpandReviewsClickBound
              : this.onCollapseReviewsClickBound
          }
        >
          <div className="more-reviews-text">
            {this.state.collapsed === true && (
              <div>
                <div>
                  <FormattedMessage
                    id={'Quest.Review.PreviousReviewsList.OlderReviews'}
                    defaultMessage={'{count} {older} {reviewType} {val}'}
                    values={{
                      count: previousReviewsCount,
                      older: older,
                      reviewType: intlReviewType,
                      val: previousReviewsCount === 1 ? review : reviewsMessage
                    }}
                    r
                  />
                </div>
                <div className="down-carat"></div>
              </div>
            )}
            {this.state.collapsed === false && (
              <div>
                <div className="up-carat"></div>
                <div>
                  <FormattedMessage
                    id={'Quest.Review.PreviousReviewsList.HidePrevious'}
                    defaultMessage={'{hide} {val}'}
                    values={{
                      hide: hidePrevious,
                      val: previousReviewsCount === 1 ? review : reviewsMessage
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  getListClass() {
    var klass = 'previous-reviews-list'
    if (this.onePreviousNoCurrent()) {
      klass = 'no-current-one-previous'
    } else {
      if (this.state.collapsed === true) {
        klass = 'previous-reviews-list collapsed'
      } else {
        klass = 'previous-reviews-list expanded'
      }
    }

    return klass
  }

  onePreviousNoCurrent() {
    return (
      this.props.reviews.length === 1 && this.props.previousReviewsNoCurrent
    )
  }

  onExpandReviewsClick() {
    this.setState({
      collapsed: false
    })
  }

  onCollapseReviewsClick() {
    this.setState({
      collapsed: true
    })
  }

  getPreviousReviewsCount() {
    const { previousReviewsNoCurrent, reviews } = this.props
    var previousReviewsCount = reviews.length

    if (previousReviewsNoCurrent) {
      previousReviewsCount -= 1
    }

    return previousReviewsCount
  }
}

PreviousReviewsList.propTypes = {
  reviews: PropTypes.array.isRequired,
  previousReviewsNoCurrent: PropTypes.bool,
  reviewType: PropTypes.string
}

PreviousReviewsList.contextTypes = {
  intl: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/review/qualityreview/PreviousReviewsList.js